(() => {
  const DAY_MS = 86400000;
  const transitDays = {
    netherlands: [1, 2],
    europe: [2, 5],
    international: [5, 15]
  };

  const isBusinessDay = (date) => {
    const day = date.getUTCDay();
    return day !== 0 && day !== 6;
  };

  const nextBusinessDay = (date) => {
    const result = new Date(date.getTime());
    do result.setTime(result.getTime() + DAY_MS); while (!isBusinessDay(result));
    return result;
  };

  const addBusinessDays = (date, amount) => {
    let result = new Date(date.getTime());
    let added = 0;
    while (added < amount) {
      result.setTime(result.getTime() + DAY_MS);
      if (isBusinessDay(result)) added += 1;
    }
    return result;
  };

  const amsterdamNow = () => {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date()).reduce((values, part) => {
      values[part.type] = part.value;
      return values;
    }, {});

    return {
      date: new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12)),
      hour: Number(parts.hour)
    };
  };

  const processingDate = () => {
    const current = amsterdamNow();
    if (!isBusinessDay(current.date) || current.hour >= 15) return nextBusinessDay(current.date);
    return current.date;
  };

  const dateRange = (start, end, locale) => {
    const localeCode = locale === 'fr' ? 'fr-FR' : locale === 'en' ? 'en-GB' : 'nl-NL';
    const day = new Intl.DateTimeFormat(localeCode, { day: 'numeric', timeZone: 'UTC' });
    const month = new Intl.DateTimeFormat(localeCode, { month: 'long', timeZone: 'UTC' });
    const full = new Intl.DateTimeFormat(localeCode, { day: 'numeric', month: 'long', timeZone: 'UTC' });

    if (start.getUTCFullYear() === end.getUTCFullYear() && start.getUTCMonth() === end.getUTCMonth()) {
      return `${day.format(start)}–${day.format(end)} ${month.format(end)}`;
    }
    return `${full.format(start)} – ${full.format(end)}`;
  };

  const placeEstimate = (root) => {
    const placement = root.dataset.ffDeliveryPlacement;
    if (placement === 'product') {
      const form = document.querySelector('.product__info-container product-form, .product__info-container .product-form');
      if (form && form.parentNode) form.insertAdjacentElement('afterend', root);
    } else if (placement === 'cart') {
      const footer = document.querySelector('.cart__footer');
      if (footer) footer.insertAdjacentElement('afterbegin', root);
    } else if (placement === 'page') {
      const heading = document.querySelector('.ff-page-delivery .title-wrapper-with-link');
      if (heading) heading.insertAdjacentElement('afterend', root);
    }
  };

  const initEstimate = (root) => {
    if (root.dataset.ffDeliveryReady === 'true') return;
    const market = transitDays[root.dataset.ffDeliveryMarket] ? root.dataset.ffDeliveryMarket : 'international';
    const locale = root.dataset.ffDeliveryLocale || 'nl';
    const dispatch = processingDate();
    const range = transitDays[market];
    const start = addBusinessDays(dispatch, range[0]);
    const end = addBusinessDays(dispatch, range[1]);
    const output = root.querySelector('[data-ff-delivery-range]');
    if (output) output.textContent = dateRange(start, end, locale);
    root.dataset.ffDeliveryReady = 'true';
    placeEstimate(root);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-ff-delivery-estimate]').forEach(initEstimate);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
